// src/components/pages/RecordingBottomCarousel.jsx
import React, { useMemo } from 'react';
import CrossfadeCarousel from './CrossfadeCarousel'; // adjust path if needed

export default function RecordingBottomCarousel() {
  const slides = useMemo(
    () => [
      { src: `${process.env.PUBLIC_URL}/images/recording/recording bottom carousel/rec 7.jpg`,  alt: 'Recording Studio 7' },
      { src: `${process.env.PUBLIC_URL}/images/recording/recording bottom carousel/rec 9.jpg`,  alt: 'Recording Studio 9' },
      { src: `${process.env.PUBLIC_URL}/images/recording/recording bottom carousel/rec 11.jpg`, alt: 'Recording Studio 11' },
      { src: `${process.env.PUBLIC_URL}/images/recording/recording bottom carousel/rec 12.jpg`, alt: 'Recording Studio 12' },
      { src: `${process.env.PUBLIC_URL}/images/recording/recording bottom carousel/rec 14.jpg`, alt: 'Recording Studio 14' },
      { src: `${process.env.PUBLIC_URL}/images/recording/recording bottom carousel/rec 15.jpg`, alt: 'Recording Studio 15' },
      { src: `${process.env.PUBLIC_URL}/images/recording/recording bottom carousel/rec 16.jpg`, alt: 'Recording Studio 16' },
      { src: `${process.env.PUBLIC_URL}/images/recording/recording bottom carousel/rec 17.jpg`, alt: 'Recording Studio 17' },
      { src: `${process.env.PUBLIC_URL}/images/recording/recording bottom carousel/rec 18.jpg`, alt: 'Recording Studio 18' },
      { src: `${process.env.PUBLIC_URL}/images/recording/recording bottom carousel/rec 20.jpg`, alt: 'Recording Studio 20' },
    ],
    []
  );

  return (
    <CrossfadeCarousel
      slides={slides}
    />
  );
}
